import { Component } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
    selector: 'app-form-button',
    styleUrls: ['form-button.component.scss'],
    template: `
    <div class="dynamic-field form-button" [formGroup]="group">
      <button type="submit" class="mt-4 btn btn-round btn-primary btn-simple btn-block">
        {{ config.label }}
      </button>
    </div>
  `,
})
export class FormButtonComponent {
    config;
    group: FormGroup;
}




// WEBPACK FOOTER //
// ./src/app/_dynamic_form/components/form-button/form-button.component.ts